











import { computed, defineComponent } from '@vue/composition-api';
import { httpUrl } from '@/renderer/scripts/http';
import store from '@/renderer/store';

export default defineComponent({
  setup() {
    const meetLogoUrl = httpUrl.staticCDNURLMap.productWemeetLogoUrl;
    const customDomainUrl = computed(() => {
      let url = '';
      const { logo } = store.getters.customDomainInfo;
      if (logo) {
        url = `${store.getters.protocol}:${logo}`;
      }
      return url;
    });
    return {
      meetLogoUrl,
      customDomainUrl,
    };
  },
});
